<div class="desk-panel-bar-actions" *ngIf="crudView.viewMode != crudView.viewModes.List">
  <ng-container *ngFor="let panel of crudView.panelItems | keyvalue:valueAscOrder">
    <button kendoButton [look]="'flat'" [class.error]="panel.value.error" (click)="selectTab(panel.key)"
      [(selected)]="panel.value.expanded">{{panel.value.description}}</button>
  </ng-container>
  <button kendoButton *ngFor="let panel of crudView.persPanelItems" [look]="'flat'" [class.error]="panel.error"
    (click)="selectTab(panel.module.destinationHostIdentifier)"
    [(selected)]="panel.expanded">{{panel.module.description}}</button>
</div>